const ChatHeader = ({
  agentData,
}) => {
  return (
    <div className='chat-header'>
      <div className='header-left'>
        <div className='chat-logo'>
          <svg
            width='15'
            height='15'
            viewBox='0 0 24 24'
            fill='none'
            stroke='white'
            strokeWidth='2.2'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path d='M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' />
          </svg>
        </div>

        <div>
          <div className='chat-title'>Aria</div>
          <div className='chat-online'>
            <span className='chat-online-dot' /> Online
          </div>
        </div>
      </div>

      <div className='header-right'>
        <img
          src={agentData?.agentProfilePicture}
          alt={agentData?.agentFullName}
          className='user-avatar'
        />
        <span className='header-name'>{agentData?.agentFullName}</span>
      </div>
    </div>
  )
}

export default ChatHeader